module.exports = __webpack_public_path__ + "static/media/loudspeaker.95dbaff2.png";